export default "__VITE_ASSET__231c2dd5__"